/**
 * Uložená česká věta → překladový klíč.
 *
 * Oznámení a zachycené toasty se ukládají jako hotový text v jazyce, ve kterém
 * vznikly. Klíč u nich chybí a doplnit ho na všech místech, kde toast vzniká,
 * by znamenalo projít každé volání. Filip 2026-09-09: „dá se to řešit po cestě
 * — při načtení se použije ten jazyk; po přepnutí jazyka bys musel udělat
 * refresh, ale to je v pořádku."
 *
 * Jde to proto obráceně: z české lokály se postaví rejstřík věta → klíč a
 * uložený text se v něm hledá při čtení. Co se najde, vyrenderuje se v jazyce
 * čtenáře; co ne, zůstane tak, jak bylo uloženo.
 *
 * Meze, ať se na to nespoléhá víc, než unese: text s dosazenými hodnotami
 * („Nod acm01: build drift") se v rejstříku nenajde, protože v lokále je pod
 * ním šablona s `{{…}}`. Na tyhle případy je klíč v `metadata.i18n`, který má
 * vždycky přednost.
 */
import cs from '../locales/cs.json';

let index: Map<string, string> | null = null;

function walk(node: unknown, prefix: string, out: Map<string, string>): void {
  if (typeof node === 'string') {
    // Šablony s dosazováním do rejstříku nepatří — nikdy se netrefí a jen by
    // zabíraly místo.
    if (node.includes('{{')) return;
    const text = node.trim();
    // První zápis vyhrává: u duplicitních vět je jedno, kterým klíčem projdou.
    if (text && !out.has(text)) out.set(text, prefix);
    return;
  }
  if (!node || typeof node !== 'object') return;
  for (const [key, value] of Object.entries(node as Record<string, unknown>)) {
    walk(value, prefix ? `${prefix}.${key}` : key, out);
  }
}

/** Klíč, pod kterým je ta věta v české lokále. Jinak null. */
export function sourceKeyFor(text: string): string | null {
  if (!index) {
    index = new Map();
    walk(cs, '', index);
  }
  return index.get(text.trim()) ?? null;
}
